import { Component, ChangeDetectionStrategy, Input, input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-address',
    templateUrl: './detail-address.component.html',
    styleUrls: ['./detail-address.component.scss'],
    standalone: false,
})
export class DetailAddressComponent {
    @Input({ required: true })
    public text!: Array<string>;

    public title = input<string>();
}
